import {validateField, clearFields} from './helpers/form'
import {
  VALIDATE_PRODUCTION_SEARCH_FIELD,
  CLEAR_PRODUCTION_SEARCH_FIELDS
} from '../../../actions/pages/production-page'

export function productionSearch(
  state = {
    valid: false,
    fields: [
      {
        name: 'SearchText',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Search text'
        }
      },
      {
        name: 'Status',
        value: 'Active',
        errors: [],
        rules: {
          title: 'Status'
        },
        placeholder: 'Any status',
        options: [
          'Draft',
          'Active'
        ]
      },
    ]
  },
  action
) {
  switch (action.type) {
    case VALIDATE_PRODUCTION_SEARCH_FIELD: {
      return validateField(state, action);
    }

    case CLEAR_PRODUCTION_SEARCH_FIELDS: {
      let newState = clearFields(state);
      
      newState.fields.map(field => {
        if (field.name === 'Status'){
          field.value = 'Active';
        }
      })

      return newState;
    }

    default:
      return state
  }
}